// extracted by mini-css-extract-plugin
module.exports = {"searchOpenButton":"flavours-xdl-searchOpenButton-4080d071","searchButtonInner":"flavours-xdl-searchButtonInner-b96493a7"};